export function areArraysShallowEqual(a, b) {
  if (a.length !== b.length) {
    return false;
  }
  a.sort();
  b.sort();
  for (var i = 0; i < a.length; i++) {
    if (a[i] !== b[i]) {
      return false;
    }
  }
  return true;
}

export function areCustomEqual(a, b) {
  if (a === b) {
    return true;
  }

  if (typeof a === "object" && typeof b === "object") {
    return JSON.stringify(a) === JSON.stringify(b);
  }

  return false;
}
